// extracted by mini-css-extract-plugin
export default {"chipsGrid":"PolicyPreview_chipsGrid__-EeL5"};